module.exports = __webpack_public_path__ + "static/img/play-white.d21c47d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/play-white.png
// module id = EzEw
// module chunks = 1